module.exports = __webpack_public_path__ + "static/logo-brand-h-99253735b1ca541b23d00bbb56bdac1e.svg";